import { neutral, radius, shadow } from 'styles/revampTokens';

const styles = {
  mapContainer: {
    height: '100%',
    position: 'relative',
    flexGrow: 1,
    '.react-flow__attribution': {
      display: 'none',
    },
    // Matches the Figma map view's minimap card (75644:18540) — a bordered,
    // shadowed rounded rectangle sitting in the bottom-right corner, rather
    // than the borderless thumbnail react-flow ships by default.
    '.react-flow__minimap': {
      'border-radius': radius.surface,
      border: `1px solid ${neutral.border}`,
      boxShadow: shadow.overlay,
      bottom: '16px',
      right: '16px',
      overflow: 'hidden',
    },
  },
};

export default styles;
